export default __webpack_public_path__ + "static/media/idling.02598ffd.svg";